import type { TestResultElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './TestResultElement'
import type { TestResultDemoType } from './testResultTypes'

const DEMO_VALUE: TestResultElementValue = {
  position: 'top',
  feedbackType: 'validation',
  resultFailTitle: t('elements.testResult.value.resultFailTitle'),
  showDiagram: true,
  showFeedback: true,
  resultFeedbackFail: t('elements.testResult.value.resultFeedbackFail'),
  resultSuccessTitle: t('elements.testResult.value.resultSuccessTitle'),
  resultFeedbackSuccess: t('elements.testResult.value.resultFeedbackSuccess'),
}

const TestResultDemo: TestResultDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.testResult.type}-demo`,
        type: CONFIG_ELEMENTS.testResult.type,
        value: DEMO_VALUE,
        font: {},
        feedback: {},
        style: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default TestResultDemo
